<div class="work-order-search-field">
  <div class="work-order-search-field_div">
    <input type="text" class="search-box" placeholder="WRK id e.g. 123" [(ngModel)]="searchTerm" (keyup.enter)="search()" />

    <button type="button" class="search-btn" (click)="search()">
      <i class="fa fa-search"></i>
    </button>

    <button type="button" class="clear-btn" [ngbTooltip]="'clear filter'" placement="bottom" (click)="clearFilter()">
      <i class="fa fa-times"></i>
    </button>
  </div>
</div>
